export const getFormattedFileSize = (fileSize: number): string => {
  if (fileSize <= 10) {
    return '< 0,01 MB';
  }

  return `${(fileSize / 1000).toFixed(2).replace('.', ',')} MB`;
};
